
      var _path, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpdate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.88 84.224A2.123 2.123 0 0 0 21 83.533l7.742-14.161a2.12 2.12 0 0 0-3.723-2.035l-5.139 9.4c-9.14-21.648.824-46.673 22.425-56.075 11.866-5.165 24.788-4.548 35.625.613a2.121 2.121 0 0 0 1.824-3.83c-11.9-5.668-26.104-6.348-39.142-.673-23.34 10.16-34.32 36.922-25.127 60.429l-8.099-5.95a2.122 2.122 0 0 0-2.512 3.42l13.008 9.553Zm84.236-48.62a2.123 2.123 0 0 0-3.117.693l-7.743 14.16a2.122 2.122 0 0 0 3.723 2.036l4.89-8.947c9.023 21.61-.947 46.535-22.493 55.914-11.866 5.164-24.788 4.548-35.625-.614a2.121 2.121 0 0 0-1.824 3.831c11.9 5.667 26.104 6.347 39.142.672 23.588-10.267 34.551-37.49 24.826-61.175l8.717 6.404a2.121 2.121 0 0 0 2.512-3.42l-13.008-9.554Z",
  fill: "#000"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 46,
  y: 84,
  width: 48,
  height: 28,
  rx: 2.719,
  transform: "rotate(-90 46 84)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3.987,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 76,
  r: 2,
  transform: "rotate(-180 60 76)",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.8805 84.2243C18.3734 84.5863 18.9993 84.7181 19.5963 84.5856C20.1934 84.4531 20.7052 84.0695 20.9986 83.5329L28.7408 69.3718C29.3026 68.344 28.9246 67.0559 27.8971 66.4939C26.8693 65.9319 25.5803 66.3089 25.0182 67.3366L19.8795 76.737C10.7386 55.0892 20.7035 30.0639 42.3043 20.6618C54.1698 15.4973 67.0919 16.1136 77.9293 21.2751C78.9869 21.7783 80.2519 21.3287 80.7555 20.2712C81.2592 19.2135 80.8102 17.9478 79.7526 17.4441C67.8538 11.7772 53.6492 11.0972 40.611 16.7722C17.2704 26.9317 6.29005 53.694 15.484 77.2009L7.38537 71.2517C6.44116 70.5582 5.11304 70.7626 4.41955 71.7067C3.72646 72.6508 3.92884 73.9781 4.87267 74.6716L17.8805 84.2243ZM102.116 35.6041C101.623 35.2421 100.997 35.1102 100.4 35.2428C99.803 35.3753 99.2921 35.7599 98.9986 36.2965L91.2555 50.4566C90.6935 51.4845 91.0723 52.7735 92.1002 53.3355C93.128 53.8974 94.4171 53.5205 94.9791 52.4928L99.8687 43.5465C108.892 65.1569 98.9224 90.0809 77.3756 99.4596C65.5101 104.624 52.588 104.008 41.7506 98.8463C40.693 98.3431 39.428 98.7927 38.9244 99.8502C38.4207 100.908 38.8697 102.174 39.9273 102.677C51.8261 108.344 66.0307 109.024 79.0689 103.349C102.657 93.082 113.62 65.8586 103.895 42.1744L112.612 48.5777C113.556 49.271 114.883 49.0668 115.577 48.1226C116.27 47.1784 116.068 45.8513 115.124 45.1578L102.116 35.6041Z\" fill=\"black\"/>\r\n<rect x=\"46\" y=\"84\" width=\"48\" height=\"28\" rx=\"2.71875\" transform=\"rotate(-90 46 84)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.9875\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"60\" cy=\"76\" r=\"2\" transform=\"rotate(-180 60 76)\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/update.d7f4c9ff394776079981dd56e563254c.svg"),
        {
          React: SvgUpdate,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      